/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'l4-policy';
const componentName = 'l4-rule-port-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const portMatchLabel = `${prefix}.portMatchLabel`;

export const ENGLISH = {
    [portMatchLabel]: 'Service Port',
};
